"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* Page images for Forms: photos drawn to JPEG, and each page uploaded. */
var _uploadStandaloneFile = require('web/services/uploadStandaloneFile');

// The longest side a page image keeps, in pixels.
 const MAX_SIDE = 2000; exports.MAX_SIDE = MAX_SIDE
const JPEG_QUALITY = 0.85

 const canvasToJpeg = (canvas) => new Promise((resolve, reject) => {
  canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('JPEG encoding failed')), 'image/jpeg', JPEG_QUALITY)
}); exports.canvasToJpeg = canvasToJpeg

/* A blank white canvas of the given size, ready to draw on. */
 const whiteCanvas = (width, height) => {
  const canvas = document.createElement('canvas')
  canvas.width = Math.max(1, Math.round(width))
  canvas.height = Math.max(1, Math.round(height))
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('No canvas')
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  return { canvas, ctx }
}; exports.whiteCanvas = whiteCanvas

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => { URL.revokeObjectURL(url); resolve(img) }
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Image did not decode')) }
  img.src = url
})

/* Decodes a photo upright (its EXIF orientation applied). Rejects when the
 * browser can't open it, as Chrome can't a HEIC. */
const decodePhoto = async (file) => {
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
    return { source: bitmap, width: bitmap.width, height: bitmap.height }
  } catch (e) {
    // Browsers draw an <img> upright too (image-orientation: from-image).
    const img = await loadImage(file)
    return { source: img, width: img.naturalWidth, height: img.naturalHeight }
  }
}

/* A photo of a page as a JPEG, upright, its long side at most MAX_SIDE. */
 const photoToJpeg = async (file) => {
  const { source, width, height } = await decodePhoto(file)
  const scale = Math.min(1, exports.MAX_SIDE / Math.max(width, height))
  const { canvas, ctx } = exports.whiteCanvas.call(void 0, width * scale, height * scale)
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height)
  if ('close' in source && typeof source.close === 'function') source.close()
  return exports.canvasToJpeg.call(void 0, canvas)
}; exports.photoToJpeg = photoToJpeg

/* Uploads one page image and gives its file key. */
 const uploadPage = async (jpeg, name) => {
  const file = new File([jpeg], name, { type: 'image/jpeg' })
  const stored = await _uploadStandaloneFile.uploadStandaloneFile.call(void 0, file)
  return stored.FileKey
}; exports.uploadPage = uploadPage
